let dateFnsLocale;

export function setDateFnsLocale(_dateFnsLocale) {
    dateFnsLocale = _dateFnsLocale;
}

export default function useDateFnsLocale() {
    return dateFnsLocale;
}
